import api from "@/lib/axiosConfig";
import { Forfait } from "@/lib/types";
import { useQuery } from "@tanstack/react-query";

async function getForfait(): Promise<Forfait> {
  const response = await api.get("/back/api/user/forfait");
  return response.data;
}

export const useGetForfait = () => {
  return useQuery({
    queryKey: ["forfait"],
    queryFn: getForfait,
  });
};
